<!-- eslint-disable vue/multi-word-component-names -->
<script lang="ts">
	let i = 0;
</script>
<script setup lang="ts">
	import { useSlots, type Ref } from "vue";

	defineProps<{
		modelValue?: string | number;
		disabled?: boolean;
		label?: string;
		error?: string | Ref<string>;
		type?: string;
		autocomplete?: string;
		placeholder?: string;
		step?: string;
	}>();
	defineEmits<{
		(e: "update:modelValue", value: string): void;
		(e: "blur"): void;
	}>();
	const errorId = `textinputerror${i++}`;

	const slots = useSlots();
</script>

<template>
	<label class="flex flex-col items-stretch relative pb-1">
		<span
			v-if="label"
			class="pl-4 mb-1 text-jca-dark-blue value-label"
		>
			{{ label }}
		</span>
		<div class="relative flex flex-col">
			<div
				v-if="slots.prepend"
				class="absolute h-full left-0 top-0 flex items-center pointer-events-none"
			>
				<slot name="prepend" />
			</div>
			<div
				v-if="slots.append"
				class="absolute h-full right-0 top-0 flex items-center pointer-events-none"
			>
				<slot name="append" />
			</div>
			<input
				:disabled="disabled"
				:placeholder="placeholder"
				:value="modelValue"
				:type="type ?? 'text'"
				:autocomplete="autocomplete"
				:aria-describedby="errorId"
				:aria-invalid="!!error"
				class="text-jca-dark-blue body-2-bold py-2 px-4 rounded-[2rem] h-12 border border-separator outline-none"
				:class="{ 'pl-12': slots.prepend, 'pr-12': slots.append }"
				:step="step"
				@blur="$emit('blur')"
				@input="
					$emit(
						'update:modelValue',
						($event.target as HTMLInputElement)?.value,
					)
				"
			/>
		</div>
		<span
			:id="errorId"
			class="error-text max-w-64 min-h-3"
		>
			<template v-if="!!error && !disabled">{{ error }}</template>
		</span>
	</label>
</template>
